/* LuxeCanvasArt — контроллер конструктора персонализации (страница товара, шаблон product.personalize). */
(function () {
  'use strict';
  var root = document.querySelector('[data-pz]');
  if (!root || !window.PNPText || !window.PNP_PZ_DATA) return;

  var DATA = window.PNP_PZ_DATA, I18N = window.PNP_PZ_I18N || {};
  var sceneKey = root.getAttribute('data-scene'), scene = DATA.scenes[sceneKey];
  if (!scene) return;

  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };

  var stage = $('[data-pz-stage]', root), canvas = $('[data-pz-canvas]', root), frameEl = $('[data-pz-frame]', root);
  var ctx = canvas.getContext('2d', { willReadFrequently: true });
  var inputs = { verse: $('[data-pz-input="verse"]', root), hi: $('[data-pz-input="hi"]', root), ref: $('[data-pz-input="ref"]', root), fam: $('[data-pz-input="fam"]', root) };
  var presetSel = $('[data-pz-preset]', root);
  var STORE_KEY = 'lc_pz_text_v1';
  // Цвета профиля рамы по порядку значений опции Framing Options Luxe (0 — Gallery Wrap): Black, White, White Oak, Antique Gold, Yellow Gold, Rose Gold, Silver, Dark Walnut, Pink.
  var FRAME_HEX = [null, '#1C1C1A', '#F4F2ED', '#C9AE86', '#B08A46', '#C9A24B', '#B98578', '#B9BCBB', '#4A3327', '#D98A9E'];

  /* ── размещение: превью встаёт на место галереи ── */
  var productEl = root.closest('.product') || $('.product');
  var mediaWrap = productEl && $('.product__media-wrapper', productEl);
  if (mediaWrap) { mediaWrap.insertBefore(stage, mediaWrap.firstChild); document.documentElement.classList.add('lc-pz-on'); }
  var scenesEl = $('.lc-pz-scenes', stage), mq = window.matchMedia('(max-width: 749px)');
  function placeScenes() { if (!scenesEl) return; if (mq.matches) root.appendChild(scenesEl); else stage.appendChild(scenesEl); }
  placeScenes(); (mq.addEventListener ? mq.addEventListener('change', placeScenes) : mq.addListener(placeScenes));

  /* ── пресеты ── */
  scene.presets.forEach(function (p, i) {
    var o = document.createElement('option'); o.value = String(i);
    o.textContent = p[0] + ' — ' + (p[2] || p[1]).replace(/[“”]/g, '');
    presetSel.appendChild(o);
  });
  function applyPreset(i) {
    var p = scene.presets[i]; if (!p) return;
    inputs.ref.value = p[0]; inputs.verse.value = p[1]; inputs.hi.value = p[2];
    onChange();
  }
  presetSel.addEventListener('change', function () { if (presetSel.value !== '') applyPreset(+presetSel.value); });

  /* ── состояние ── */
  function tpl() { var r = $('[data-pz-tpl]:checked', root); return r ? r.value : 'T1'; }
  function state() { return { verse: inputs.verse.value.trim(), hi: inputs.hi.value.trim(), ref: inputs.ref.value.trim(), fam: inputs.fam.value.trim(), tpl: tpl() }; }
  function hasText(s) { return !!(s.verse || s.hi || s.fam); }

  function restore() {
    var saved = null; try { saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) {}
    if (saved && hasText(saved)) {
      inputs.verse.value = saved.verse || ''; inputs.hi.value = saved.hi || ''; inputs.ref.value = saved.ref || ''; inputs.fam.value = saved.fam || '';
      var r = $('[data-pz-tpl][value="' + (saved.tpl || 'T1') + '"]', root); if (r) r.checked = true;
    } else { presetSel.value = '0'; var p = scene.presets[0]; inputs.ref.value = p[0]; inputs.verse.value = p[1]; inputs.hi.value = p[2]; }
  }
  function persist(s) { try { localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {} }

  /* ── рендер ── */
  var bg = new Image(), bgReady = false, fontsReady = false, raf = 0;
  bg.onload = function () { bgReady = true; schedule(); };
  bg.src = root.getAttribute('data-bg');
  var F = window.PNPText.fonts;
  var fontList = ['500 20px "' + F.caps + '"', '500 20px "' + F.serif + '"', 'italic 400 20px "' + F.serif + '"', '400 20px "' + F.script + '"'];
  if (document.fonts && document.fonts.load) {
    Promise.all(fontList.map(function (f) { return document.fonts.load(f, 'AÉç'); })).then(function () { fontsReady = true; schedule(); }, function () { fontsReady = true; schedule(); });
  } else { fontsReady = true; }

  function sizeCanvas() {
    var cssW = canvas.clientWidth || 600, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = Math.max(600, Math.min(1500, Math.round(cssW * dpr))), H = Math.round(W * 2 / 3);
    if (canvas.width !== W) { canvas.width = W; canvas.height = H; }
  }
  function draw() {
    raf = 0; if (!bgReady) return; sizeCanvas();
    var s = state();
    window.PNPText.render(ctx, canvas.width, canvas.height, bg, {
      tpl: s.tpl, verse: s.verse, hi: s.hi, ref: s.ref, fam: s.fam,
      box: scene.box, scrim: scene.scrim || 0, align: 'center'
    });
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(draw); }

  /* ── счётчики, свойства заказа ── */
  function counters() {
    Object.keys(inputs).forEach(function (k) {
      var el = $('[data-pz-count="' + k + '"]', root), max = +inputs[k].getAttribute('maxlength'), n = inputs[k].value.length;
      if (el) { el.textContent = n + ' / ' + max; el.classList.toggle('is-full', n >= max); }
    });
  }
  function forms() { return $$('form[action*="/cart/add"]').filter(function (f) { return f.getAttribute('data-type') === 'add-to-cart-form'; }); }
  function setProp(form, name, value) {
    var el = form.querySelector('input[data-pz-prop="' + name + '"]');
    if (!value) { if (el) el.remove(); return; }
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.setAttribute('data-pz-prop', name); el.name = 'properties[' + name + ']'; form.appendChild(el); }
    el.value = value;
  }
  function syncProps(s) {
    var title = (document.querySelector('.product__title h1') || {}).textContent || sceneKey;
    forms().forEach(function (f) {
      setProp(f, I18N.propVerse || 'Opening line', s.verse);
      setProp(f, I18N.propHi || 'Main line', s.hi);
      setProp(f, I18N.propRef || 'Reference', s.ref);
      setProp(f, I18N.propFam || 'Family line', s.fam);
      setProp(f, I18N.propTpl || 'Lettering', s.tpl === 'T3' ? (I18N.tplT3 || 'All in serif') : (I18N.tplT1 || 'Capitals and script'));
      // служебное поле для печатного рендера (скрыто в корзине и на кассе: имя начинается с «_»)
      setProp(f, '_pz', JSON.stringify({ v: DATA.v, scene: sceneKey, tpl: s.tpl, fmt: '3x2', verse: s.verse, hi: s.hi, ref: s.ref, fam: s.fam }));
    });
  }

  function autosize() { var ta = inputs.verse; ta.style.height = 'auto'; ta.style.height = (ta.scrollHeight + 2) + 'px'; }
  function onChange() { autosize(); var s = state(); counters(); persist(s); syncProps(s); hideError(); schedule(); }
  Object.keys(inputs).forEach(function (k) {
    inputs[k].addEventListener('input', function () { if (k !== 'fam') presetSel.value = matchPreset(); onChange(); });
    inputs[k].addEventListener('focus', function () { document.documentElement.classList.add('lc-pz-typing'); });
    inputs[k].addEventListener('blur', function () { document.documentElement.classList.remove('lc-pz-typing'); setTimeout(schedule, 60); });
  });
  function matchPreset() {
    for (var i = 0; i < scene.presets.length; i++) { var p = scene.presets[i]; if (p[0] === inputs.ref.value && p[1] === inputs.verse.value && p[2] === inputs.hi.value) return String(i); }
    return '';
  }
  $$('[data-pz-tpl]', root).forEach(function (r) { r.addEventListener('change', onChange); });

  var dot = $('[data-pz-dot]', root);
  if (dot) dot.addEventListener('click', function () {
    var f = inputs.fam, a = f.selectionStart == null ? f.value.length : f.selectionStart, b = f.selectionEnd == null ? f.value.length : f.selectionEnd;
    var ins = (a > 0 && f.value[a - 1] !== ' ' ? ' ' : '') + '· ';
    f.value = (f.value.slice(0, a) + ins + f.value.slice(b)).slice(0, +f.getAttribute('maxlength'));
    var pos = Math.min(a + ins.length, f.value.length); f.focus(); f.setSelectionRange(pos, pos); onChange();
  });

  /* ── рама вокруг превью по выбранному обрамлению ── */
  function syncFrame() {
    var fs = $('variant-selects fieldset, variant-radios fieldset'); if (!fs) return;
    var radios = $$('input[type="radio"]', fs), idx = 0;
    radios.forEach(function (r, i) { if (r.checked) idx = i; });
    var hex = FRAME_HEX[idx] || null;
    frameEl.classList.toggle('is-framed', !!hex);
    frameEl.style.setProperty('--pz-frame', hex || 'transparent');
    setTimeout(schedule, 240);
  }
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) setTimeout(syncFrame, 0); });

  /* ── проверка перед добавлением в корзину ── */
  var okBox = $('[data-pz-ok]'), errEl = $('[data-pz-error]'), confirmEl = $('[data-pz-confirm]');
  function showError(msg) {
    if (!errEl) return; errEl.textContent = msg; errEl.hidden = false;
    if (confirmEl) { confirmEl.classList.remove('is-shake'); void confirmEl.offsetWidth; confirmEl.classList.add('is-shake'); confirmEl.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  }
  function hideError() { if (errEl) errEl.hidden = true; }
  if (okBox) okBox.addEventListener('change', hideError);
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var s = state(), msg = '';
    if (!hasText(s)) msg = I18N.needText || 'Add at least one line of text.';
    else if (okBox && !okBox.checked) msg = I18N.needOk || 'Check the box to confirm the wording is correct.';
    if (msg) { e.preventDefault(); e.stopImmediatePropagation(); showError(msg); return; }
    syncProps(s);
  }, true);

  /* ── мобильный: когда превью прилипло к верху, делаем его компактным ── */
  if (mediaWrap && 'IntersectionObserver' in window) {
    var sentinel = document.createElement('div'); sentinel.style.cssText = 'display:block;height:1px;margin-bottom:-1px;pointer-events:none;width:100%';
    mediaWrap.parentNode.insertBefore(sentinel, mediaWrap);
    new IntersectionObserver(function (en) {
      var stuck = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      document.documentElement.classList.toggle('lc-pz-stuck', stuck && mq.matches); setTimeout(schedule, 220);
    }, { threshold: 0 }).observe(sentinel);
  }

  /* ── запуск ── */
  restore(); presetSel.value = matchPreset(); autosize(); counters(); syncProps(state()); syncFrame(); schedule();
  window.addEventListener('resize', schedule);
  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(canvas);
})();
